export default __webpack_public_path__ + "static/media/blog-img91.61a9fb80.jpg";